// PatchCenterLayout.jsx
import { Outlet } from 'react-router-dom';
import { PolicyAutomationProvider } from '../../providers/GroupPolicyAutomationProvider';
import { CreateGroupProvider } from '../../providers/CreateGroupProvider';

const PolicyAutomationLayout = () => {
  return (
    <PolicyAutomationProvider>
      <CreateGroupProvider>
        <Outlet />
      </CreateGroupProvider>
    </PolicyAutomationProvider>
  );
};

export default PolicyAutomationLayout;
